<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 予約状況の説明
  </div>
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>予約状況の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/reservation.png" width="100%">
        </div>


        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 条件ボタン
        </div>
        <div class="manual-explain">
          クリックすることで<a [href]="selectReservationDialogLink">予約状況検索条件ダイアログ</a>を表示します。<br>
          予約状況検索条件ダイアログで検索条件を設定すると、その内容で予約状況を検索します。(初期表示時は無条件です)
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 削除ボタン
        </div>
        <div class="manual-explain">
          クリックすることで選択した情報を削除します。<br>
          ボタンは、一覧の削除チェックボックスにチェックを入れる事で活性化されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Filter・属性
        </div>
        <div class="manual-explain">
          予約状況一覧に表示されているデータのフィルタリングを行います。<br>
          環境（プレ）はプレ環境で予約したデータ、環境（本番）は本番環境で予約したデータを示します。<br>
          ※フィルタリングの対象は、名称、展示ID、予約者、メールアドレス、環境、属性（プルダウンによるフィルタリング）
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 予約状況一覧
        </div>
        <div class="manual-explain">
          登録済みの予約状況の一覧が表示されます。<br>
          編集アイコンをクリックすることで編集画面が表示されます。<br>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Reservation Status
  </div>
  
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
  
    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Reservation Status</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_reservation.png" width="100%">
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 条件ボタン
        </div>
        <div class="manual-explain">
          Click to display the <a [href]="selectReservationDialogLink">Reservation Status Search Conditions Dialog</a>.<br>
          When you set search conditions in the Reservation Status Search Conditions Dialog, the reservation status will be searched based on those conditions. (By default, there are no conditions)
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Delete Button
        </div>
        <div class="manual-explain">
          Clicking this button will delete the selected information.<br>
          The button is activated by checking the delete checkboxes in the list.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Filter/Attributes
        </div>
        <div class="manual-explain">
          Filters the data displayed in the reservation status list.<br>
          Environment (Pre) indicates data reserved in the pre-environment, while Environment (Live) indicates data reserved in the live environment.<br>
          * Filtering criteria: Name, Exhibit ID, Reserver, Email Address, Environment, Attributes (filtered via dropdown)
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Reservation Status List
        </div>
        <div class="manual-explain">
          Displays a list of registered reservation statuses.<br>
          Clicking the edit icon will display the edit screen.<br>
        </div>
  
      </mat-card-content>
    </mat-card>
  
  </div>  
</div>